import { z } from 'zod';

const categoryObject = z.object({
  name: z.string({ required_error: 'Nome é obrigatório' }),
  value: z.string({ required_error: 'Valor é obrigatório' }),
  label: z.string({ required_error: 'Label é obrigatório' }),
  field: z.string({ required_error: 'Field é obrigatório' }),
  level: z.number({ required_error: 'Level é obrigatório' }),
});

const objectiveMargin = z.object({
  level: z.number({ required_error: 'Level é obrigatório' }),
  field: z.string({ required_error: 'Field é obrigatório' }),
  name: z.string({ required_error: 'Name é obrigatório' }),
});

export type LevelsType = z.infer<typeof categoryObject>;

const categorySchema = z.object({
  categoryLevels: z.array(categoryObject),
  objectiveMargin: objectiveMargin,
  categoryRoleCalculation: objectiveMargin,
  optimizationCategory: objectiveMargin,
});

export type CategoryLevels = z.infer<typeof categorySchema>;

export default categorySchema;
